import axios from "axios";
const BACKEND_BASEURL = process.env.REACT_APP_BACKEND_URL;
const baseUrl = `${BACKEND_BASEURL}api/auth/`;
export const getUser = async () => {
  const response = await axios.get(baseUrl + "getUserData", {
    withCredentials: true,
    timeout: 10000,
  });
  return response;
};
